let GoogleMap = require('./google-map');

module.exports = GoogleMap;
